import { Button, Card, Col, DatePicker, Row } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { AppStateContext, useAppContext } from "../../context/AppContext";
import useRequest from "../../hooks/useRequest";
import { Avatar, List, Skeleton } from "antd";
import moment from "moment";
import apiPath from "../../constants/apiPath";
import Notification from "../../assets/images/notification-bell.svg";
import { Severty, ShowToast } from "../../helper/toast";
// import DeleteModal from "../../components/DeleteModal";
function NotificationList() {
  const { setPageHeading } = useContext(AppStateContext);
  const [loading, setLoading] = useState();
  const [list, setList] = useState([]);
  const [show, setShow] = useState(false);
  const [showAllDelete, setShowAllDelete] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [selected, setSelected] = useState("");

  const { language, setRefreshAppContext } = useAppContext();
  const [pagination, setPagination] = useState({
    current: 1,
    total: 10,
  });

  const { request } = useRequest();

  const dates = {
    today: moment(new Date()).format("YYYY-MM-DD"),
    yesterday: moment(new Date().getTime() - 24 * 60 * 60 * 1000).format(
      "YYYY-MM-DD"
    ),
  };

  const fetchData = () => {
    // request({
    //   url:
    //     apiPath.notification +
    //     `?status=${""}&page=${pagination ? pagination.current : 1}&pageSize=${pagination && pagination?.total ? pagination?.total : 10
    //     }&search=${""}`,
    //   method: "GET",
    //   onSuccess: (data) => {
    //     setList(data.data);
    //     setLoading(false);
    //   },
    //   onError: (err) => {
    //     console.log(err);
    //     setLoading(false);
    //   },
    // });
  };

  const deleteNotification = (id) => {
    // setLoading(true);
    // request({
    //   url: `${apiPath.notification}/delete/${selected}`,
    //   method: "DELETE",
    //   onSuccess: ({ data, message }) => {
    //     ShowToast(message, Severty.SUCCESS);
    //     setRefresh((prev) => !prev);
    //     setLoading(false);
    //     setSelected("");
    //     setTimeout(() => {
    //       setRefreshAppContext(true);
    //     }, 20);
    //   },
    //   onError: (err) => {
    //     ShowToast(err?.response?.data?.message, Severty.ERROR);
    //     console.log(err);
    //     setLoading(false);
    //   },
    // });
  };

  const readAllNotifcation = () => {
    // request({
    //   url: `${apiPath.notificationRead}`,
    //   method: "POST",
    //   onSuccess: ({ data }) => {
    //     ShowToast("Notification  Read All Successfully", Severty.SUCCESS);
    //     setRefresh((prev) => !prev);
    //     setTimeout(() => {
    //       setRefreshAppContext(true);
    //     }, 20);
    //   },
    //   onError: (err) => {
    //     console.log(err);
    //   },
    // });
  };

  useEffect(() => {
    // setLoading(true);
    fetchData();
  }, [refresh]);

  useEffect(() => {
    setPageHeading("Notifications");
  }, []);

  return (
    <>
      <div className="tabled quoteManagement">
        <Card
          bordered={false}
          className="criclebox tablespace mb-24 main-new-notification-4545"
        >
          <div className="notification-main-wrap">
            {loading ? (
              <Skeleton />
            ) : (
              <>
                {list.length > 0 ? (
                  <>
                    <div className="main-dltall-not-all">
                      <Button
                        disabled={!list?.length}
                        className="deleteall-main-button"
                        onClick={() => {
                          setShowAllDelete(true);
                        }}
                      >
                        {"Delete All"}
                      </Button>
                      <Button
                        disabled={!list?.length}
                        className="deleteall-main-button"
                        onClick={() => {
                          readAllNotifcation();
                        }}
                      >
                        {"Read All"}
                      </Button>
                    </div>
                    {list.map((data, index) => {
                      console.log(data, "datadatadata");
                      return (
                        <div className="notification-card">
                          <h6>
                            {moment(data._id).format("YYYY-MM-DD") ===
                            dates.today
                              ? "Today's Notifications"
                              : moment(data._id).format("YYYY-MM-DD") ===
                                dates.yesterday
                              ? "Yesterday's Notifications"
                              : moment(data._id).format("YYYY-MM-DD")}
                          </h6>
                          <List
                            key={"groupItem" + index}
                            itemLayout="horizontal"
                            dataSource={data.notifications}
                            renderItem={(item, index) => (
                              <List.Item
                                className={`list-notfy ${
                                  item?.is_read
                                    ? "Notification-read"
                                    : "Notification-unread"
                                }`}
                              >
                                <List.Item.Meta
                                  title={
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        gap: "5px",
                                      }}
                                    >
                                      <span className="tital-notfy">
                                        {item?.title}
                                      </span>
                                      <span className="dics-notfy">
                                        {moment(item?.created_at)?.format(
                                          "hh:mm A"
                                        )}
                                      </span>
                                    </div>
                                  }
                                  avatar={
                                    <Avatar
                                      className="noti-avtar"
                                      src={
                                        item?.data?.user?.image
                                          ? item?.data?.user?.image
                                          : Notification
                                      }
                                    />
                                  }
                                  description={item?.description}
                                />
                              </List.Item>
                            )}
                          />
                        </div>
                      );
                    })}
                  </>
                ) : (
                  <h3>No Notification Found</h3>
                )}
              </>
            )}
          </div>

          {/* <div>
                <DatePicker onChange={(v)=>alert(v)} />
              </div> */}
        </Card>
      </div>
    </>
  );
}

export default NotificationList;
